$(document).ready(function () {
    function isYouTubeId(value) {
        return /^[a-zA-Z0-9_-]{11}$/.test(value || '');
    }

    $(document).on('click', '.wp-block-pulp-video .video-trigger, .wp-block-pulp-sponsors-intro .video-trigger', function () {
        const $trigger = $(this);
        const $block = $trigger.closest('.wp-block-pulp-video, .feature-img');
        const $container = $trigger.closest('.block-container, .feature-img');
        const $embed = $container.find('.video-embed');

        if ($block.hasClass('is-playing')) {
            return;
        }

        const videoId = $trigger.attr('data-video');

        if (!isYouTubeId(videoId)) {
            return;
        }

        const src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&mute=1&playsinline=1&rel=0';

        $embed.html(
            '<iframe src="' + src + '" title="YouTube video player" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>'
        );

        $embed.removeAttr('hidden').attr('tabindex', '-1');
        $block.addClass('is-playing');

        $embed[0].focus();
    });
});
